import { Box } from "@mui/material";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import {
  EXCHANGES_DIMENSIONS_DASHBOARD_ID,
  EXCHANGES_DIMENSIONS_EXCHANGE_FILTER_ID,
  EXCHANGES_DIMENSIONS_FILTER_ID,
} from "@/api/dimensions/constants";
import { LoadingFallback } from "@/components/LoadingFallback";
import { DimensionsOmniIframe } from "@/features/Dimensions/DimensionsOmniIframe";

const optionalNonEmptyString = z
  .string()
  .optional()
  .transform((value) =>
    value !== undefined && value.length > 0 ? value : undefined,
  );

/** Search params for Exchanges-only filters (separate from Dragon Tiles `tabId` on the index route). */
const exchangesSearchSchema = z.object({
  period: optionalNonEmptyString,
  /**
   * Exchange name to pre-apply to the dashboard's Exchange filter (the
   * reporting icon on an exchange card links here with it). Day and Device
   * Type keep the dashboard defaults.
   */
  exchange: optionalNonEmptyString,
});

export const Route = createFileRoute("/_auth/dimensions/$siteId/exchanges")({
  component: RouteComponent,
  pendingComponent: LoadingFallback,
  validateSearch: zodValidator(exchangesSearchSchema),
});

function RouteComponent() {
  const { siteId } = useParams({
    from: "/_auth/dimensions/$siteId/exchanges",
  });
  const { exchange } = Route.useSearch();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}
      >
        <DimensionsOmniIframe
          siteId={siteId}
          dashboardId={EXCHANGES_DIMENSIONS_DASHBOARD_ID}
          filterId={EXCHANGES_DIMENSIONS_FILTER_ID}
          filters={
            exchange
              ? [
                  {
                    filter_id: EXCHANGES_DIMENSIONS_EXCHANGE_FILTER_ID,
                    values: [exchange],
                  },
                ]
              : undefined
          }
          title="Dimensions — Exchanges"
        />
      </Box>
    </Box>
  );
}
